import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useLanguage } from "../contexts/LanguageContext";

export const LEGAL_EMAIL = "Cs2-hub.ru@yandex.ru";
export const LEGAL_OPERATOR = "ИП Нерушаев Роман Алексеевич";

export const LEGAL_DOCS = [
  { to: "/terms", key: "legal.terms" },
  { to: "/privacy", key: "legal.privacy" },
  { to: "/personal-data-consent", key: "legal.consent" },
  { to: "/cookie-policy", key: "legal.cookie" },
] as const;

const Wrap = styled.footer`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 0 24px;
  font-size: 13px;
  line-height: 20px;
  color: ${(p) => p.theme.colors.textMuted};
  .docs {
    display: flex;
    flex-wrap: wrap;
    gap: 0 20px;
  }
  a {
    display: inline-flex;
    align-items: center;
    min-height: 32px;
    color: ${(p) => p.theme.colors.textSecondary};
  }
  a:hover {
    color: ${(p) => p.theme.colors.text};
    text-decoration: underline;
  }
  @media (max-width: 767px) {
    a {
      min-height: 44px;
    }
  }
`;

export default function LegalLinks({ className }: { className?: string }) {
  const { t } = useLanguage();
  return (
    <Wrap className={className} aria-label={t("legal.footer_label")}>
      <nav className="docs" aria-label={t("legal.footer_label")}>
        {LEGAL_DOCS.map((d) => (
          <Link key={d.to} to={d.to}>
            {t(d.key)}
          </Link>
        ))}
      </nav>
      <span>
        {LEGAL_OPERATOR} · <a href={`mailto:${LEGAL_EMAIL}`}>{LEGAL_EMAIL}</a>
      </span>
    </Wrap>
  );
}
